import { ArrowLeftOutlined } from "@ant-design/icons"
import React, { useState } from "react"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"
import {
  changeRestaurant,
  resetWhichItemsAreSuggested,
  toggleAddToCartItem,
  removeItemFromSuggestedItemsList,
  emptyDeliveryDotComCart,
} from "../../redux/actionCreators/planDinnner"
import "./RestaurantSelected.scss"
import Menu from "../Menu/Menu"
import PartnerAway from "../../components/PartnerAway/PartnerAway"
import { viewOrder } from "../../redux/actionCreators/orderAndPayments"
import { CartPopup } from "../CartPopup/CartPopup"
import { invitePartnerToChat } from "../../redux/actionCreators/invitePeople"
import {
  GO_BACK_FROM_MENU,
  TAKE_ME_BACK,
  GO_BACK_FROM_MENU_PARTNER,
  WARNING_TO_CLEAR_CART,
  DATE_ICON_SUFFIX,
  BACK_FROM_MEAL,
  CONTINUE,
  COMBINED_ORDER_LABEL,
  COMBINED_ORDER_TOOLTIP,
  CANCEL,
} from "../../constants/messages"
import _ from "../../utils/lodashUtils"
import {
  FirebaseContext,
  FIREBASE_STATE_KEYS,
  FirebaseService,
} from "../../firebase"
import { isPartnerAway, getPartnerNameorNickName } from "../../utils/helpers"
import { TextTag as Text, CustomModal, Button } from "../../atoms"
import { Modal } from "antd"
import Tag from "../Tag/Tag"
import { PageHeader } from "../../molecules/PageHeader"
import { Tooltip } from "antd"
import { emitter } from "../../utils/emitter"
import { CUSTOM_EVENTS } from "../../constants/commons"

const RestaurantSelected = props => {
  const { emptyDeliveryDotComCart, history, user, deliveryDotComCart } = props
  const { dateState, userState, partnerState } = React.useContext(
    FirebaseContext
  )
  const partnerScreen = _.get(partnerState, "activeScreen", "")
  const partnerOnline = _.get(partnerState, "presence.isOnline", false)
  const showPartnerAway = isPartnerAway(partnerScreen, partnerOnline)
  const [backModalVisibility, setBackModalVisibility] = useState(false)
  const [browserBack, setBrowserBack] = useState(false)
  const [combinedOrderDetailModal, setCombinedOrderDetailModal] = useState(
    false
  )

  const [modal, toggleModal] = React.useState(false)
  const acceptedRestaurant = _.get(
    dateState,
    FIREBASE_STATE_KEYS.ACCEPTED_RESTAURANT,
    {}
  )
  const resetRestaurant = _.get(
    dateState,
    `${FIREBASE_STATE_KEYS.ACCEPTED_RESTAURANT}.${FIREBASE_STATE_KEYS.RESET_RESTAURANT}`,
    false
  )
  const resetBy = _.get(
    dateState,
    `${FIREBASE_STATE_KEYS.ACCEPTED_RESTAURANT}.${FIREBASE_STATE_KEYS.RESET_BY}`
  )

  let backModal
  const partnerReadyForCheckout = _.get(
    partnerState,
    FIREBASE_STATE_KEYS.READY_FOR_CHECKOUT,
    false
  )
  const userReadyForCheckout = _.get(
    userState,
    FIREBASE_STATE_KEYS.READY_FOR_CHECKOUT,
    false
  )
  const partnerUuid = _.get(partnerState, "userDetails.uuid")
  const userUuid = _.get(userState, "userDetails.uuid")
  const wasIReadyForCheckoutFirst =
    _.get(dateState, FIREBASE_STATE_KEYS.FIRST_USER_READY_FOR_CHECKOUT, ``) ===
    _.get(user, "uuid")

  const disableBackButton =
    showPartnerAway ||
    modal ||
    backModalVisibility ||
    combinedOrderDetailModal ||
    (partnerReadyForCheckout &&
      userReadyForCheckout &&
      wasIReadyForCheckoutFirst)
  React.useEffect(() => {
    // Delete back modal if user and partner are ready for checkout
    if (partnerReadyForCheckout && userReadyForCheckout && backModal) {
      backModal.destroy()
    }
  }, [userReadyForCheckout, partnerReadyForCheckout])
  React.useEffect(() => {
    history.listen((location, action) => {
      if (action === "POP" && location.pathname === "/plan-new-date") {
        setBrowserBack(true)
        goBackToRestaurants()
      }
    })
  }, [])

  /* Back to Plan a date screen Modal Emitter Registry and toggling modal */

  const toggleBackModal = value => () => {
    setBackModalVisibility(value)
  }

  React.useEffect(() => {
    const showBackModalListener = emitter.addListener(
      CUSTOM_EVENTS.SHOW_BACK_TO_RESTARAUNTS_SCREEN_MODAL,
      toggleBackModal(true)
    )
    const hideBackModalListener = emitter.addListener(
      CUSTOM_EVENTS.HIDE_BACK_TO_RESTARAUNTS_SCREEN_MODAL,
      toggleBackModal(false)
    )
    return () => {
      showBackModalListener.remove()
      hideBackModalListener.remove()
    }
  }, [])

  const partnerDisplayName = getPartnerNameorNickName(partnerState)
  const goBackToRestaurants = () => {
    Modal.destroyAll()
    emitter.fire(CUSTOM_EVENTS.SHOW_BACK_TO_RESTARAUNTS_SCREEN_MODAL, [])
  }
  const goBackToRestaurantsForPartner = () => {
    toggleModal(true)
  }

  const combinedOrdersToolTip = () => {
    combinedOrderDetailModal
      ? setCombinedOrderDetailModal(false)
      : setCombinedOrderDetailModal(true)
  }

  const isOrderCombined = _.get(
    dateState,
    FIREBASE_STATE_KEYS.IS_ORDER_COMBINED
  )

  return (
    <div id="RestaurantSelected">
      {/* <ProgressBar percent={50} /> */}
      <div>
        {showPartnerAway && <PartnerAway {...props} />}
        {resetRestaurant && resetBy !== user.uuid && !modal
          ? goBackToRestaurantsForPartner()
          : null}
      </div>
      <PageHeader
        onClick={goBackToRestaurants}
        btnText={BACK_FROM_MEAL}
        disabled={disableBackButton}
        icon={<ArrowLeftOutlined />}
        headerText={`${DATE_ICON_SUFFIX}`}
      />
      <div id="dinnerPlanSection">
        <div id="dinnerPlan">
          <div className="cart-box">
            <div id="SelectedRestaurantName">
              <Text textType="bodyHeading">
                {_.get(
                  acceptedRestaurant,
                  FIREBASE_STATE_KEYS.RESTAURANT_NAME,
                  ""
                )}
              </Text>
              {isOrderCombined && (
                <div className="combined-tag">
                  <Tooltip
                    trigger="click"
                    placement="right"
                    title={COMBINED_ORDER_TOOLTIP}
                    className="tag-container"
                  >
                    <Tag
                      text={COMBINED_ORDER_LABEL}
                      onClickIcon={combinedOrdersToolTip}
                      icon={true}
                    />
                  </Tooltip>
                </div>
              )}
            </div>
            <section className="cart-plates">
              <CartPopup />
            </section>
          </div>
          <div>
            <Menu />
          </div>
        </div>
      </div>
      <CustomModal
        destroyOnClose={true}
        title={GO_BACK_FROM_MENU}
        visible={backModalVisibility}
        keyboard={false}
        footer={[
          <Button
            className="save-btn"
            key={TAKE_ME_BACK}
            onClick={async () => {
              const isCartEmpty =
                _.get(deliveryDotComCart, "cart.length", 0) > 0 ? false : true
              //go back from menu to restaurant list clear user cart
              emptyDeliveryDotComCart(
                acceptedRestaurant[FIREBASE_STATE_KEYS.RESTAURANT_ID],
                !isCartEmpty
              )
              FirebaseService.write(
                null,
                `${FirebaseService.getDefaultPath()}${user.uuid}/${
                  FIREBASE_STATE_KEYS.SUGGESTED_TO_PARTNER
                }`
              )
              FirebaseService.patch(
                {
                  [FIREBASE_STATE_KEYS.RESET_RESTAURANT]: true,
                  [FIREBASE_STATE_KEYS.RESET_BY]: user.uuid,
                },
                `${FirebaseService.getDefaultPath()}/${
                  FIREBASE_STATE_KEYS.ACCEPTED_RESTAURANT
                }`
              )
              FirebaseService.write(
                null,
                `${FirebaseService.getDefaultPath()}${userUuid}/${
                  FIREBASE_STATE_KEYS.UNREAD_NOTIFICATION
                }`
              )
              FirebaseService.write(
                null,
                `${FirebaseService.getDefaultPath()}${partnerUuid}/${
                  FIREBASE_STATE_KEYS.UNREAD_NOTIFICATION
                }`
              )
              await FirebaseService.setActiveRoute("/plan-new-date")
              history.push("/plan-new-date")
            }}
          >
            {TAKE_ME_BACK}
          </Button>,
          <Button
            key="cancel"
            btnType="bordered"
            onClick={() => {
              emitter.fire(
                CUSTOM_EVENTS.HIDE_BACK_TO_RESTARAUNTS_SCREEN_MODAL,
                []
              )
              if (browserBack) {
                history.push("/confirm-date")
              }
            }}
          >
            {CANCEL}
          </Button>,
        ]}
      >
        <Text>{WARNING_TO_CLEAR_CART(partnerDisplayName)}</Text>
      </CustomModal>
      <CustomModal
        destroyOnClose={true}
        title={GO_BACK_FROM_MENU_PARTNER(partnerDisplayName)}
        visible={modal}
        keyboard={false}
        footer={[
          <Button
            className="save-btn"
            onClick={async () => {
              const isCartEmpty =
                _.get(deliveryDotComCart, "cart.length", 0) > 0 ? false : true
              //go back from menu to restaurant list clear user cart
              emptyDeliveryDotComCart(
                acceptedRestaurant[FIREBASE_STATE_KEYS.RESTAURANT_ID],
                !isCartEmpty
              )
              FirebaseService.write(
                null,
                `${FirebaseService.getDefaultPath()}${user.uuid}/${
                  FIREBASE_STATE_KEYS.SUGGESTED_TO_PARTNER
                }`
              )
              FirebaseService.write(
                null,
                `${FirebaseService.getDefaultPath()}/${
                  FIREBASE_STATE_KEYS.ACCEPTED_RESTAURANT
                }`
              )
              await FirebaseService.setActiveRoute("/plan-new-date")
              history.push("/plan-new-date")
            }}
          >
            {CONTINUE(partnerDisplayName)}
          </Button>,
        ]}
      />
    </div>
  )
}

const mapStateToProps = state => {
  return {
    partners: state.invitePeople.partnerDetails,
    user: state.auth.user,
    deliveryDotComCart: _.get(state.planDinner, "deliveryDotComCart"),
  }
}

export default connect(mapStateToProps, {
  changeRestaurant,
  resetWhichItemsAreSuggested,
  toggleAddToCartItem,
  removeItemFromSuggestedItemsList,
  viewOrder,
  invitePartnerToChat,
  emptyDeliveryDotComCart,
})(withRouter(RestaurantSelected))
